module.exports = __webpack_public_path__ + "static/media/GA_wordmark_novare_Black-2.1c9b52d4.svg";